require('./angular-material-icons');
module.exports = 'ngMdIcons';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-material-icons/index.js
 ** module id = 38
 ** module chunks = 1
 **/